module.exports = __webpack_public_path__ + "img/emoji_164.98804f9f.png";